/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Schoolyearsafterelementary2Inputs */



/**

* @param {_Field_Schoolyearsafterelementary2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_schoolyearsafterelementary2 = /** @type {((inputs?: _Field_Schoolyearsafterelementary2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Schoolyearsafterelementary2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Schulbesuchsjahre bis zum Ende der Grundschule")
});
export { _field_schoolyearsafterelementary2 as "_field_schoolyearsAfterElementary" }